<template>
	<div class="msg" v-show="show">
		<h1> <i class="fas fa-exclamation-circle"></i> {{ msg }} </h1>
	</div>
</template>

<script>
export default {
	name: 'ItemEmpty',
	props: ['show', 'msg']
}
</script>

<style lang="scss" scoped>
	.msg{
		background-color: #EBF0F9;
		display:flex;
		justify-content: center;
		align-items: center;
		padding: 20px;
		width: 100%;
		color: black;
		border-radius: 5px;

		h1 {
			display: flex;
			align-items: center;
			i {
				font-size: 25px;
				margin-right: 10px;
			}
		}
	}
</style>
